(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["drop-countdown"] && !Shopify.designMode) return;
  try {
    
  class DropCountdown extends HTMLElement {
    connectedCallback() {
      this.at = Date.parse(this.dataset.at);
      if (Number.isNaN(this.at)) return;
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
    tick() {
      const left = Math.max(0, this.at - Date.now());
      const parts = { d: left / 864e5, h: (left / 36e5) % 24, m: (left / 6e4) % 60, s: (left / 1e3) % 60 };
      for (const [unit, value] of Object.entries(parts)) {
        this.querySelector(`[data-unit="${unit}"]`).textContent = String(Math.floor(value)).padStart(2, '0');
      }
      if (left === 0) {
        clearInterval(this.timer);
        this.classList.add('is-live');
        this.querySelector('.drop__live').hidden = false;
      }
    }
  }
  customElements.define('drop-countdown', DropCountdown);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  class ProductRecs extends HTMLElement {
    connectedCallback() {
      new IntersectionObserver(async ([e], io) => {
        if (!e.isIntersecting) return;
        io.disconnect();
        try {
          const html = await (await fetch(this.dataset.url)).text();
          const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-recs]');
          if (fresh && fresh.children.length) this.querySelector('[data-recs]').replaceWith(fresh);
        } catch {}
      }, { rootMargin: '400px' }).observe(this);
    }
  }
  customElements.define('product-recs', ProductRecs);

  } catch(e) { console.error(e); }
})();
})();
